var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tongxin-modal",
    class: {
      show: _vm.isVisible
    }
  }, [_c('div', {
    staticClass: "tongxin-modal__content"
  }, [_c('div', {
    staticClass: "tongxin-modal__header"
  }, [_c('div', {
    staticClass: "tongxin-modal__icon result-modal-icon",
    class: {
      success: _vm.state.isSuccess,
      error: !_vm.state.isSuccess
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_vm.state.isSuccess ? [_c('path', {
    attrs: {
      "d": "M22 11.08V12a10 10 0 1 1-5.93-9.14"
    }
  }), _c('polyline', {
    attrs: {
      "points": "22 4 12 14.01 9 11.01"
    }
  })] : [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('line', {
    attrs: {
      "x1": "15",
      "y1": "9",
      "x2": "9",
      "y2": "15"
    }
  }), _c('line', {
    attrs: {
      "x1": "9",
      "y1": "9",
      "x2": "15",
      "y2": "15"
    }
  })]], 2)]), _c('h2', {
    staticClass: "tongxin-modal__title"
  }, [_vm._v(_vm._s(_vm.state.title))])]), _c('div', {
    staticClass: "tongxin-modal__body"
  }, [_c('p', {
    staticClass: "tongxin-modal__text"
  }, [_vm._v(_vm._s(_vm.state.message))]), _vm.state.errorReason ? _c('div', {
    staticClass: "error-reason"
  }, [_c('div', {
    staticClass: "error-reason-title"
  }, [_vm._v("錯誤原因")]), _c('div', {
    staticClass: "error-reason-text"
  }, [_vm._v(_vm._s(_vm.state.errorReason))])]) : _vm._e()]), _c('div', {
    staticClass: "tongxin-modal__buttons"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "flex-grow": "1"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("確定")])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }